"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CommentsIcon = void 0;
var React = _interopRequireWildcard(require("react"));
var _SvgIcon = require("../SvgIcon");
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function (e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != typeof e && "function" != typeof e) return {
    default: e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n.default = e, t && t.set(e, n), n;
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
} /**
  * This file was generated by the build:icons script
  * See Notion for details on how to add icons
  */
const CommentsIcon = props => /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, _extends({}, props, {
  viewBox: "0 0 24 24"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "m3.75 18.16.085-.034c.354-.142.933-.41 1.415-.747h.001a4.341 4.341 0 0 0 .243-.185 2.539 2.539 0 0 0 .61-.736c.22-.403.257-.751.168-.8C4.153 14.491 3 12.741 3 10.497 3 6.909 6.56 4 10.953 4c4.393 0 7.954 2.909 7.954 6.497s-3.561 6.496-7.954 6.496c-.276 0-.427 0-.578-.008-.182-.011-.364-.034-.765-.086l-.026-.003c-.275-.036-.666.217-1.176.545-.277.179-.59.38-.937.57a7.136 7.136 0 0 1-.947.433c-.282.102-.57.183-.857.243a5.873 5.873 0 0 1-1.918.082c-.04-.059-.062-.585 0-.609Zm6.089-3.248c-.735-.094-1.338.178-1.594.304a2.08 2.08 0 0 0-1.008-1.31C5.657 13.037 5 11.905 5 10.496 5 8.373 7.268 6 10.953 6c3.686 0 5.954 2.372 5.954 4.497 0 2.124-2.268 4.496-5.954 4.496-.33 0-.404 0-.488-.007-.1-.007-.22-.022-.626-.074ZM12.4 18.09a2.987 2.987 0 0 1-.369-.201c4.085-.391 7.334-3.016 7.867-6.34a4.19 4.19 0 0 1 .727 1.258 3.863 3.863 0 0 1 .231 1.309c0 1.54-.767 2.75-2.18 3.575a6.48 6.48 0 0 1-.135.077c-.069.038-.03.335.172.657a1.792 1.792 0 0 0 .463.496c.198.15.428.282.64.388l.027.014a5.927 5.927 0 0 0 .483.215c.044.017.029.389 0 .43a4.272 4.272 0 0 1-1.963-.23l-.009-.003a4.374 4.374 0 0 1-.153-.059c-.458-.188-.848-.439-1.171-.647-.124-.08-.238-.154-.342-.215-.2-.116-.362-.187-.49-.171l-.018.002a8.12 8.12 0 0 1-.542.06 3.398 3.398 0 0 1-.136.006h-.03l-.243.001a6.772 6.772 0 0 1-1.543-.175 6.32 6.32 0 0 1-1.286-.447Z"
}));
exports.CommentsIcon = CommentsIcon;